/* eslint-disable react-native/no-inline-styles */
import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import i18n from 'i18n-js';

import { isAndroid, isPhone } from '@helpers';

import { SmallLoading } from '@components/loading';
import TouchableElement from '@components/common/touchableElement';
import { font } from '@styles/fonts';
import { scale, width } from '@components/frame';
import Svg from '@styles/icons/svg';

const DefaultValue = ({ pressHoverColor, item, item: { ValueIcon }, C, textColor, valueColor, isSuperBig }) => {
  const noArrow = item.noArrow && !isSuperBig;
  const hideArrow = !item.hideArrow || isSuperBig;
  return (
    <View key={item.name}>
      {isPhone ? (
        <View
          style={[
            {
              paddingRight: noArrow ? (isPhone && hideArrow ? 0 : scale(15)) : scale(15),
              justifyContent: 'space-between',
              alignItems: 'center',
              flexDirection: 'row',
              height: scale(52) - (isAndroid ? StyleSheet.hairlineWidth : 0),
            },
          ]}
        >
          <View
            style={[
              {
                flexDirection: 'row',
                alignItems: 'center',
                flex: 1,
                justifyContent: 'space-between',
              },
            ]}
          >
            <View style={{ flexDirection: 'column', flex: 1 }}>
              {item.isLoading ? (
                <View style={{ paddingRight: scale(item.hideArrow ? 0 : 6) }}>
                  <SmallLoading />
                </View>
              ) : (
                <View style={{ paddingRight: scale(item.hideArrow ? 0 : 12) }}>
                  {item.valueFunction ? (
                    item.value()
                  ) : (
                    <Text
                      style={[
                        {
                          color: C(pressHoverColor(textColor)),
                          fontVariant: ['tabular-nums'],
                        },
                        font.Body,
                      ]}
                    >
                      {ValueIcon && <ValueIcon />}
                      {item.value ? i18n.t(String(item.value) || '') : ''}
                    </Text>
                  )}
                </View>
              )}
              <View>
                <Text
                  style={[
                    {
                      color: C(pressHoverColor(valueColor)),
                      width: scale(220),
                    },
                    font['Caption 1'],
                  ]}
                >
                  {i18n.t(item.name || '')}
                </Text>
              </View>
            </View>
            {hideArrow && (
              <View style={{ opacity: noArrow ? 0 : 1 }}>
                <Svg icon="chevronRightLight" color="Label/Light/Quinary" width={scale(7)} height={scale(12)} />
              </View>
            )}
          </View>
        </View>
      ) : (
        <View
          style={[
            {
              paddingRight: noArrow ? (isPhone && hideArrow ? 0 : scale(15)) : scale(15),
              justifyContent: 'space-between',
              alignItems: 'center',
              flexDirection: 'row',
              height: scale(41.5) - (isAndroid ? StyleSheet.hairlineWidth : 0),
            },
          ]}
        >
          <View>
            <Text
              style={[
                {
                  color: C(pressHoverColor(textColor)),
                  width: scale(220),
                },
                font.Body,
              ]}
            >
              {i18n.t(item.name || '')}
            </Text>
          </View>
          <View
            style={[
              {
                flexDirection: 'row',
                alignItems: 'center',
                flex: 1,
                justifyContent: 'space-between',
              },
              // isPhone ? { justifyContent: 'flex-end' } : { justifyContent: 'space-between' },
            ]}
          >
            {isSuperBig ? (
              <View />
            ) : item.isLoading ? (
              <View style={{ paddingRight: scale(item.hideArrow ? 0 : 6) }}>
                <SmallLoading />
              </View>
            ) : (
              <View style={{ paddingRight: scale(item.hideArrow ? 0 : 12) }}>
                {item.valueFunction ? (
                  item.value()
                ) : (
                  <Text
                    style={[
                      {
                        color: C(pressHoverColor(valueColor)),
                        fontVariant: ['tabular-nums'],
                      },
                      font.Body,
                    ]}
                  >
                    {ValueIcon && <ValueIcon />}
                    {item.value ? i18n.t(String(item.value) || '') : ''}
                  </Text>
                )}
              </View>
            )}
            {item.alert && (
              <View
                style={{
                  marginRight: scale(20),
                  width: scale(24),
                  height: scale(24),
                  borderRadius: scale(24) / 2,
                  backgroundColor: C('Status/Light/Missing'),
                  justifyContent: 'center',
                  alignContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Text style={[font.Body, { color: C('Label/Light/AlwaysDark Primary') }]}>{item.alert}</Text>
              </View>
            )}
            {hideArrow && (
              <View style={{ opacity: noArrow ? 0 : 1 }}>
                <Svg icon="chevronRightLight" color="Label/Light/Quinary" width={scale(7)} height={scale(12)} />
              </View>
            )}
          </View>
        </View>
      )}
    </View>
  );
};

export default (props) => {
  const {
    item,
    index,
    array,
    C,
    roundTop,
    roundBottom,
    topBorder = false,
    bottomBorder = false,
    topBorderSmall = false,
    bg = false,
    textColor = 'Label / Light / Primary',
    valueColor = 'Label / Light / Tertiary',
  } = props;

  let styles = {};
  const lastIndex = index === array.length - 1;

  if (lastIndex && !bottomBorder) {
    styles = {
      ...styles,
      borderBottomWidth: 0,
    };
  }

  if (roundTop) {
    styles = {
      ...styles,
      borderTopLeftRadius: scale(10),
      borderTopRightRadius: scale(10),
    };
  }
  if (roundBottom) {
    styles = {
      ...styles,
      borderBottomLeftRadius: scale(10),
      borderBottomRightRadius: scale(10),
    };
  }

  return (
    <TouchableElement
      onPress={() => {
        if (item.onClick) {
          item.onClick();
        }
      }}
      hitSlop={{}}
    >
      {({ pressHoverColor, boxStyle }) => (
        <View
          style={[
            !item.noArrow && boxStyle,
            {
              marginTop: isAndroid ? StyleSheet.hairlineWidth : 0,
              paddingLeft: scale(15),
              backgroundColor: C(pressHoverColor(bg || 'Background / Light / Field')),
              zIndex: array.length - index,
            },
            topBorder &&
              index === 0 &&
              !topBorderSmall && {
                borderTopColor: C('Hairline / Light / No trans'),
                borderTopWidth: StyleSheet.hairlineWidth,
              },
            topBorder &&
              index === 0 &&
              !topBorderSmall && {
                borderTopColor: C('Hairline / Light / No trans'),
                borderTopWidth: StyleSheet.hairlineWidth,
              },
            lastIndex && bottomBorder && { borderBottomColor: C('Hairline / Light / No trans'), borderBottomWidth: StyleSheet.hairlineWidth },

            styles,
          ]}
        >
          <View
            style={[
              { width: '100%' },
              !lastIndex && { borderBottomColor: C('Hairline / Light / No trans'), borderBottomWidth: StyleSheet.hairlineWidth },
              topBorder &&
                index === 0 &&
                topBorderSmall && {
                  borderTopColor: C('Hairline / Light / No trans'),
                  borderTopWidth: StyleSheet.hairlineWidth,
                },
            ]}
          >
            <DefaultValue {...{ pressHoverColor, item, C, textColor, valueColor }} />
          </View>
        </View>
      )}
    </TouchableElement>
  );
};
